/** Minimal user fields for shell display helpers. */
export interface ShellUser {
  first_name?: string;
  last_name?: string;
  email?: string;
  role?: string;
}

const ROLE_LABELS: Record<string, string> = {
  super_admin: "Super Administrator",
  org_admin: "Organization Administrator",
  provider: "Physician / Provider",
  physician: "Physician / Provider",
  nurse: "Nurse / MA",
  front_desk: "Front Desk",
  billing_staff: "Billing Staff",
  billing: "Billing Staff",
  patient: "Patient (portal)",
};

export function getUserRoleLabel(role?: string): string {
  if (!role) return "Administrator";
  return ROLE_LABELS[role] ?? role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getUserDisplayName(user: ShellUser | null | undefined): string {
  if (!user) return "Administrator";
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ").trim();
  return fullName || user.email || "Administrator";
}

export function getUserInitials(user: ShellUser | null | undefined): string {
  if (!user) return "AD";
  const first = user.first_name?.[0] ?? "";
  const last = user.last_name?.[0] ?? "";
  const initials = `${first}${last}`.toUpperCase();
  return initials || user.email?.[0]?.toUpperCase() || "AD";
}
